import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationClinicCityListResponse,
  IConfigurationClinicCityListResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useStaffProfileCitiesAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [cities, setCities] = useState<IConfigurationClinicCityListResponseData[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response = await axios.get<IConfigurationClinicCityListResponse>(
        `${CONFIGURATION_APIS.CLINIC_CITY_LIST.baseURL}?source=vms`,
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      setCities(response.data?.data ?? []);
    } catch (error) {
      setCities([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        if (axiosError.config) {
          sendCurl(axiosError.config["curlCommand"]);
        }
      }
    }
  }, [configuration]);

  return { execute, cities };
};
